import React, { useEffect, useState } from 'react';
import GnbHeader from '../components/GnbHeader';
import Navigation from '../components/Navigation';
import '../styles/Session.css';
import { sessionList } from '../mockData/mockData';
import { useWindowWidth } from '../js/calculator';
import AlcFooter from '../components/AlcFooter';

const Session = ({ lang, bg }) => {
	const [id, setId] = useState(-1);
	const now = new Date();
	const year = now.getFullYear();

	const isMobile = useWindowWidth();

	return (
		<div id="wrapper-session">
			<GnbHeader bg={bg} lang={lang} />
			<Navigation bg={bg} lang={lang} />
			<div className="session-container">
				<div className="session-title-box">
					<span className="session-title" style={{ color: '#DA1C28' }}>
						ALC 2026&nbsp;
					</span>
					<span
						className="session-title"
						style={{ color: '#ffffff' }}
					>{`${lang === 'en' ? 'Sessions' : '세션'}`}</span>
				</div>
				<div className="session-table">
					{!isMobile && (
						<div className="session-row">
							{/* <span className='sortation'>{lang === 'en'? 'Sortation':'구분'}</span> */}
							<span className="topic">{lang === 'en' ? 'Topic' : '주제'}</span>
							{/* <div className='arrow'></div> */}
						</div>
					)}
					{sessionList?.map((ele, idx) => {
						return isMobile ? (
							<div className="session-column-mobile" key={idx}>
								<div
									className="title-box"
									onClick={() => {
										if (ele.descriptionEn !== '') {
											if (id === idx) {
												setId(-1);
											} else {
												setId(idx);
											}
										}
									}}
								>
									<div className="left">
										{/* <span className='sortation'>{lang === 'en'? ele.partEn:ele.partKo}</span> */}
										<span className="title">{lang === 'en' ? ele.titleEn : ele.titleKo}</span>
									</div>
									{ele.descriptionEn !== '' && (
										<div className="right">
											<img
												src={
													idx === id
														? 'https://image.chosun.com/alc/2025/alc-description-up.svg'
														: 'https://image.chosun.com/alc/2025/alc-description-down.svg'
												}
											/>
										</div>
									)}
								</div>
								<span className={`description ${idx === id ? 'show' : ''}`}>
									{lang === 'en' ? ele.descriptionEn : ele.descriptionKo}
								</span>
							</div>
						) : (
							<div className="session-column" key={idx}>
								{/* <span className='sortation'>{lang === 'en'? ele.partEn:ele.partKo}</span> */}
								<div className="description-box">
									<div
										className="title-box"
										onClick={() => {
											if (ele.descriptionEn !== '') {
												if (id === idx) {
													setId(-1);
												} else {
													setId(idx);
												}
											}
										}}
									>
										<span className="topic">{lang === 'en' ? ele.titleEn : ele.titleKo}</span>
										{ele.descriptionEn !== '' && (
											<div className="arrow">
												<img
													src={
														idx === id
															? 'https://image.chosun.com/alc/2025/alc-description-up.svg'
															: 'https://image.chosun.com/alc/2025/alc-description-down.svg'
													}
												/>
											</div>
										)}
									</div>
									<span className={`description ${idx === id ? 'show' : ''}`}>
										{lang === 'en' ? ele.descriptionEn : ele.descriptionKo}
									</span>
								</div>
							</div>
						);
					})}
				</div>
			</div>
			<AlcFooter lang={lang} bg={bg} />
		</div>
	);
};

export default Session;
